module.exports = __webpack_public_path__ + "static/media/6 1 Ordforstaelse Intro.704969ad.mp3";